import BASE_URL from '../../config/env';
import {apiClient} from '../apiClient';

export type FolderTreeItem = {
  id: string;
  text: string;
  parent: string | undefined;
  isGroup: boolean;
  type: string;
  searchGroupTypeCode: string | null;
  a_attr: any | null;
  isSelected: boolean;
  state: any | null;
  li_attr: any | null;
  saveSearchSecurityGroupId: number;
  documentCount: number;
  textWithoutCount: string | null;
};

const folderEndPoint = (path: string) =>
  `${BASE_URL}/tagsfoldering/api/v1/${path}`;

export const getFoldersData = async (
  securityGroupId = 0
): Promise<FolderTreeItem[]> => {
  const {data} = await apiClient.get<FolderTreeItem[]>(
    folderEndPoint('tagsandfolders/tree/folder'),
    {
      params: {
        securityGroupId,
        toggelValue: 0,
      },
    }
  );
  return data;
};

export const getSavedSearchListData = async (): Promise<FolderTreeItem[]> => {
  const {data} = await apiClient.get<FolderTreeItem[]>(
    'reporting/api/v1/review/document-audit/search-list'
  );
  return data;
};

export const getProductionSetsData = async (
  securityGroupId = 0,
  isProduction = true
): Promise<FolderTreeItem[]> => {
  const {data} = await apiClient.get<FolderTreeItem[]>(
    'productions/api/v1/proview/tree/production',
    {
      params: {
        securityGroupId,
        productionTypeCode: isProduction ? 'PRODUCTION' : 'EXPORT',
      },
    }
  );
  return data;
};

type JsTreeResponse = {
  jsTreeData: FolderTreeItem[];
};

export const getAssignmentsData = async (): Promise<FolderTreeItem[]> => {
  const {data} = await apiClient.get<JsTreeResponse>(
    'assignments/api/v1/bulkactions/tags?actionType=BulkAssign'
  );
  return data.jsTreeData;
};
